import React, { FC, ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { routes } from 'routes/cmsRoutes'
import { useAuthContext } from 'utils/auth'
import { Group } from 'utils/services/auth'

type Props = {
  allowedForGroups: Group[]
  children: ReactElement | ReactElement[]
  redirectTo?: string
}

export const ProtectedRoute: FC<Props> = ({ allowedForGroups, redirectTo = routes.NOT_FOUND, children }) => {
  const { groups } = useAuthContext()

  const hasAccess = groups.some((group: Group) => allowedForGroups.includes(group))

  return hasAccess ? <>{children}</> : <Navigate to={redirectTo} replace />
}
